// Phase accent colour - the single colour mapping for a case's workflow
// phase, shared by every surface that renders a phase or a phase-tinted
// status pill (the Work Queue's DetailPanel/GroupNav/StatsBar/SearchDropdown,
// the patient timeline's JourneyView, and the Accounts Patients tab). Keys
// must match the workflow taxonomy's phase values (StatusMeta.phase /
// MACRO_LABELS on the backend). Previously lived inside
// components/work-queue/constants.ts - moved here so a non-work-queue
// surface can reuse the exact same colours without importing across feature
// folders or holding a second copy that could drift.
export const PHASE_HEX: Record<string, string> = {
    Design: 'rgb(139,92,246)', // violet
    Approval: 'rgb(55,115,168)', // blue
    Manufacturing: 'rgb(34,197,94)', // green
    Redesign: 'rgb(168,85,247)', // purple
    Treatment: 'rgb(59,130,246)', // blue
    Refinement: 'rgb(236,72,153)', // pink
    Retention: 'rgb(20,184,166)', // teal
    Hold: 'rgb(249,115,22)', // orange
    Done: 'rgb(107,114,128)' // gray
};

// Convert "rgb(r,g,b)" → "rgba(r,g,b,alpha)" for tinted phase backgrounds.
export function phaseTint(rgbStr: string | undefined, alpha: number): string {
    if (!rgbStr) return 'transparent';
    const inner = rgbStr.replace(/^rgb\(|\)$/g, '');
    return `rgba(${inner}, ${alpha})`;
}

// Phase accent as a StatusPill colour override. An absent or unrecognised phase
// falls back to neutral gray, matching how an unmatched phase reads elsewhere.
const NEUTRAL_PHASE_COLOR = { text: '#6b7280', background: '#f3f4f6' };

export function phaseColorOverride(phase: string | null | undefined): {
    text: string;
    background: string;
} {
    const color = phase ? PHASE_HEX[phase] : undefined;
    return color ? { text: color, background: phaseTint(color, 0.12) } : NEUTRAL_PHASE_COLOR;
}
